import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect, useRef } from '@redneckz/uni-jsx/lib/hooks';
import { useBool } from '@redneckz/uni-jsx/lib/hooks/useBool';
import { useEventListener } from '@redneckz/uni-jsx/lib/hooks/useEventListener';
import { useOutsideClick } from '@redneckz/uni-jsx/lib/hooks/useOutsideClick';
import { useLink } from '../../hooks/useLink.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
export const DropdownMenu = JSX(({ className = '', items, activeItem, ariaLabel = 'Меню' }) => {
    const [isVisible, { setFalse, toggle }] = useBool(false);
    const ref = useOutsideClick(setFalse);
    const dropdownRef = useRef(null);
    const changeDropdownPosition = useCallback(({ isOpened, buttonRef, menuRef }) => {
        if (isOpened && buttonRef.current && menuRef.current) {
            const dropdownRect = menuRef.current.getBoundingClientRect();
            const dropdownButtonRect = buttonRef.current.getBoundingClientRect();
            const newDropdownPosition = globalThis.innerWidth - dropdownRect.width;
            if (dropdownRect.right >= globalThis.innerWidth) {
                menuRef.current.style.left = `${newDropdownPosition}px`;
            }
            else if (dropdownButtonRect.left > dropdownRect.left) {
                if (newDropdownPosition > dropdownButtonRect.left) {
                    menuRef.current.style.left = '';
                }
                else {
                    menuRef.current.style.left = `${newDropdownPosition}px`;
                }
            }
        }
    }, [isVisible]);
    useEventListener(globalThis, 'resize', () => changeDropdownPosition({ isOpened: isVisible, buttonRef: ref, menuRef: dropdownRef }));
    useEffect(() => {
        changeDropdownPosition({ isOpened: isVisible, buttonRef: ref, menuRef: dropdownRef });
    }, [isVisible]);
    return (_jsxs("div", { className: style(isVisible ? 'rounded-md shadow-blue-gray' : '', className), ref: ref, role: "navigation", children: [_jsx("button", { type: "button", className: "group/btn flex justify-between items-center h-6", "aria-label": ariaLabel, onClick: toggle, role: "button", "aria-labelledby": "labeldiv", children: Array(3)
                    .fill(null)
                    .map((_, i) => (_jsx("div", { className: "w-[3px] h-[3px] rounded mr-2xs bg-primary-text group-hover/btn:bg-primary-hover group-data-transparent:bg-white" }, String(i)))) }), _jsx("div", { ref: dropdownRef, className: style('absolute flex flex-col rounded-md bg-white p-xl pb-xs w-56 z-40', {
                    hidden: !isVisible,
                }), "aria-hidden": !isVisible, children: renderDropdownItems(items, activeItem) })] }));
});
export const DropdownMenuItem = JSX(({ isActive, ...rest }) => {
    const link = useLink();
    const { text, href, target, onClick } = link(rest);
    return (_jsx("a", { className: style('text-l font-light pb-m hover:text-primary-main', {
            'text-primary-main': isActive,
        }), href: href, target: target, onClick: onClick, role: "link", ...getAspectsAttributes(rest?.data), children: text }));
});
const renderDropdownItems = (items, activeItem) => items?.map((item, i) => (_jsx(DropdownMenuItem, { isActive: item === activeItem, ...item }, item?.text ?? String(i))));
//# sourceMappingURL=DropdownMenu.js.map